import React, {ChangeEvent, useCallback, useState} from 'react';
import {CrossIcon, SearchIcon} from 'src/ui-components/Iconpack';
import {debounce} from 'lodash';

interface SearchBarProps {
    onTextChange: (text: string) => void;
    customStyles?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({onTextChange, customStyles}) => {
    const [searchText, setSearchText] = useState('');

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleDebouncedSearch = useCallback(
        debounce((value: string) => {
            onTextChange(value);
        }, 500),
        [],
    );

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.target.value);
        handleDebouncedSearch(event.target.value);
    };

    const handleDiscard = () => {
        setSearchText('');
        onTextChange('');
    };

    return (
        <div
            className={`relative flex items-center rounded-[8px] border-[0.1px] bg-white px-3 py-2 text-[14px] ${customStyles}`}>
            <SearchIcon />
            <input
                type='text'
                value={searchText}
                placeholder='Start typing to search...'
                onChange={handleChange}
                className='flex-grow px-2 outline-none'
            />
            {searchText.length > 0 && (
                <button
                    onClick={handleDiscard}
                    className='absolute right-3 text-gray-500 hover:text-gray-700 focus:outline-none'>
                    <CrossIcon />
                </button>
            )}
        </div>
    );
};

export default SearchBar;
